/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/book-list',
    name: '图书列表',
    view: 'BookList'
  },
  {
    path: '/link-list',
    name: '漂流链列表',
    view: 'LinkList'
  },
  {
    path: '/comment-list',
    name: '评论列表',
    view: 'CommentList'
  },
  {
    path: '/user-list',
    name: '用户列表',
    view: 'UserList'
  },
  {
    path: '/keyword-list',
    name: '敏感词',
    view: 'KeywordList'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/sayhello',
    name: 'Say Hello',
    view: 'SayHello'
  }
]
